"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DateBuilder {
    constructor(date) {
        this.oneMinute = 60;
        this.setHoursUtc = (hours, minutes, seconds, ms) => new Date(Date.UTC(this.date.getFullYear(), this.date.getMonth(), this.date.getDate(), hours, minutes, seconds, ms));
        this.date = new Date(date);
    }
    static get fromCurrent() {
        return new DateBuilder(new Date());
    }
    startOfDay() {
        this.date = this.setHoursUtc(0, 0, 0, 0);
        return this;
    }
    endOfDay() {
        this.date = this.setHoursUtc(23, 59, 59, 999);
        return this;
    }
    toIsoString() {
        return this.date.toISOString();
    }
    addSeconds(seconds) {
        this.date.setSeconds(this.date.getSeconds() + seconds);
        return this;
    }
    addMinutes(minutes) {
        return this.addSeconds(this.oneMinute * minutes);
    }
    addDays(days) {
        const newDate = this.date.getDate() + days;
        this.date.setDate(newDate);
        return this;
    }
    subtractSeconds(seconds) {
        this.date.setSeconds(this.date.getSeconds() - seconds);
        return this;
    }
    subtractMinutes(minutes) {
        return this.subtractSeconds(this.oneMinute * minutes);
    }
    subtractDays(days) {
        const newDate = this.date.getDate() - days;
        this.date.setDate(newDate);
        return this;
    }
    addMonths(months) {
        const currentMonth = this.date.getMonth();
        this.date.setMonth(currentMonth + months);
        return this;
    }
    addYears(years) {
        const currentYear = this.date.getFullYear();
        this.date.setFullYear(currentYear + years);
        return this;
    }
    get unixMs() {
        return this.date.getTime();
    }
    get unixS() {
        return Math.round(this.unixMs / 1000);
    }
    get isInFuture() {
        return this.date > DateBuilder.fromCurrent.date;
    }
    get isInPast() {
        return this.date < DateBuilder.fromCurrent.date;
    }
}
exports.DateBuilder = DateBuilder;
//# sourceMappingURL=date-builder.js.map